// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-form-wrap .auth-form-box {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.75rem;
}
.auth-form-wrap .auth-form-box .form-control {
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 0.75rem;
}
.auth-form-wrap .btn-box {
  display: flex !important;
  justify-content: center !important;
  margin-top: 2rem !important;
}
@media screen and (max-width: 991.98px) {
  .auth-form-wrap .auth-form-box {
    margin: 0 -0.5rem;
  }
  .auth-form-wrap .auth-form-box .form-control {
    padding: 0 0.5rem;
  }
  .auth-form-wrap .btn-box {
    margin-top: 1.25rem !important;
  }
}
@media screen and (max-width: 767.98px) {
  .auth-form-wrap .btn-box {
    margin-top: 1rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PasswordEntry/LoginFormModalStyle.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,eAAA;EACA,kBAAA;AAAJ;AAEI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAAN;AAKE;EACE,wBAAA;EACA,kCAAA;EACA,2BAAA;AAHJ;AAME;EACE;IACE,iBAAA;EAJJ;EAMI;IACE,iBAAA;EAJN;EAQE;IACE,8BAAA;EANJ;AACF;AASE;EACE;IACE,2BAAA;EAPJ;AACF","sourcesContent":[".auth-form-wrap {\n  .auth-form-box {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -0.75rem;\n\n    .form-control {\n      flex: 0 0 100%;\n      max-width: 100%;\n      padding: 0 0.75rem;\n    }\n\n  }\n  \n  .btn-box {\n    display: flex !important;\n    justify-content: center !important;\n    margin-top: 2rem !important;\n  }\n\n  @media screen and (max-width: 991.98px) {\n    .auth-form-box {\n      margin: 0 -0.5rem;\n\n      .form-control {\n        padding: 0 0.5rem;\n      }\n    }\n\n    .btn-box {\n      margin-top: 1.25rem !important;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    .btn-box {\n      margin-top: 1rem !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
